'use client'

import {
  type IntercomBootProps,
  IntercomProvider as IntercomProviderImpl,
} from 'react-use-intercom'

import isEmpty from 'lodash/fp/isEmpty'

import type { ChildrenProps, CoreUser } from '../types'

import { fullName, phoneNumber } from '../helpers/user'
import useUser from '../hooks/useUser'

type Props = {
  bootProps?: IntercomBootProps
  user?: false | CoreUser | null
} & ChildrenProps

export default function IntercomProvider({ bootProps, children, user }: Props) {
  const { user: connectedUser } = useUser()

  const appId =
    process.env.INTERCOM_APP_ID || process.env.NEXT_PUBLIC_INTERCOM_APP_ID

  if (isEmpty(appId)) {
    return false
  }

  const userToUse = user === false ? null : (user ?? connectedUser)

  return (
    <IntercomProviderImpl
      appId={appId}
      autoBoot
      autoBootProps={{
        avatar: isEmpty(userToUse?.pictureUrl)
          ? undefined
          : { imageUrl: userToUse?.pictureUrl, type: 'avatar' },
        createdAt: userToUse?.createdAt?.getTime() ?? undefined,
        email: userToUse?.email || undefined,
        hideDefaultLauncher: true,
        name: fullName(userToUse) || undefined,
        phone: phoneNumber(userToUse),
        userHash: userToUse?.hash || undefined,
        userId: userToUse?.uuid || undefined,
        ...bootProps,
      }}
      shouldInitialize
    >
      {children}
    </IntercomProviderImpl>
  )
}
